// Copyright (c) 2016 Deere & Company

import DealerPercentage from './dealer-percentage';
import t from 'tcomb';

const LaborAdditiveSummary = t.struct({
    completePercentage: t.Number,
    dealerPercentages: t.list(DealerPercentage, 'DealerPercentage'),
    group: t.String,
    targetCompletion: t.Number
}, {
    name: 'LaborAdditiveSummary',
    strict: true
});

export const getDefaultState = () => new LaborAdditiveSummary({
    completePercentage: 0,
    dealerPercentages: [],
    group: '',
    targetCompletion: 0
});

export default LaborAdditiveSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/labor-additive-summary.js